import React from "react";
import { motion } from "framer-motion";
import "./Footer.css";
import logo from "../Assets/Website Logo 1.png";
import twitterIcon from "../Assets/X.png";
import instagramIcon from "../Assets/Instagram.png";
import facebookIcon from "../Assets/FB.png";
import linkedinIcon from "../Assets/Linkdin.png";
import youtubeIcon from "../Assets/Youtube.png";
import homeeIcon from "../Assets/Homee.png";

const Footer = ({ isDarkMode = false }) => {
  const socialLinks = [
    {
      icon: <img src={homeeIcon} alt="Homee" className="w-8 h-8" />,
      url: "#", // Add appropriate URL for Homee
      label: "Homee",
    },
    {
      icon: <img src={linkedinIcon} alt="LinkedIn" className="w-8 h-8" />,
      url: "https://www.linkedin.com/company/homeegram-community/",
      label: "LinkedIn",
    },
    {
      icon: <img src={facebookIcon} alt="Facebook" className="w-8 h-8" />,
      url: "https://www.facebook.com/share/1D7RG3wMoi/",
      label: "Facebook",
    },
    {
      icon: <img src={instagramIcon} alt="Instagram" className="w-8 h-8" />,
      url: "https://www.instagram.com/homeegram",
      label: "Instagram",
    },
    {
      icon: <img src={youtubeIcon} alt="YouTube" className="w-8 h-8" />,
      url: "https://youtube.com/@homeegram?si=b9CMfddLJHsVnuxp",
      label: "YouTube",
    },
    {
      icon: <img src={twitterIcon} alt="Twitter" className="w-8 h-8" />,
      url: "https://twitter.com/homeegram",
      label: "Twitter",
    },
  ];

  return (
    <footer className="footer-container">
      <div className="footer-main">
        {/* Brand Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="footer-brand"
        >
          <motion.img
            src={logo}
            alt="Homeeera Logo"
            className="footer-logo"
            whileHover={{ scale: 1.05, rotate: 5 }}
            transition={{ type: "spring", stiffness: 300 }}
          />

          <div className="footer-tagline">
            <span>Build</span>
            <br />
            <span>Dreams</span>
            <br />
            <span>
              Together<span className="footer-dot">.</span>
            </span>
          </div>
        </motion.div>

        {/* Links Section */}
        <div className="footer-links">
          {/* Company Column */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="footer-col"
          >
            <div className="footer-col-title">Company</div>
            <motion.a
              href="#vision"
              whileHover={{ x: 5, color: "#fef200" }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              Our Vision
            </motion.a>
            <motion.a
              href="#contact"
              whileHover={{ x: 5, color: "#fef200" }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              Connect Us
            </motion.a>
          </motion.div>

          {/* Platforms Column */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="footer-col"
          >
            <div className="footer-col-title">Platforms</div>
            <motion.a
              href="https://homeegram.com/"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ x: 5, color: "#fef200" }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              Homeegram
            </motion.a>
            <motion.a
              href="https://homeeframes.com/"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ x: 5, color: "#fef200" }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              Homeeframes
            </motion.a>
            <motion.a
              whileHover={{ x: 5, color: "#fef200" }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              Homeeschool
            </motion.a>
          </motion.div>

          {/* Corporate Office Column */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="footer-col"
          >
            <div className="footer-col-title">Corporate Office</div>
            <div className="footer-address">
              NH 544, First Floor,
              <br />
              G.I Square, Above Lenskart,
              <br />
              Kothakulangara, Angamaly,
              <br />
              Kerala, India
            </div>
          </motion.div>
        </div>
      </div>

      <hr className="footer-divider" />

      {/* Bottom Section */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8, delay: 0.4 }}
        className="footer-bottom"
      >
        {/* Social Icons */}
        <div className="footer-socials">
          {socialLinks.map((social, index) => (
            <motion.a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.label}
              className="footer-social-icon"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: 0.5 + index * 0.1 }}
              whileHover={{ scale: 1.2, y: -5, color: "#fef200" }}
              whileTap={{ scale: 0.9 }}
            >
              {social.icon}
            </motion.a>
          ))}
        </div>

        {/* Copyright */}
        <div className="footer-copyright">
          All Right Reserved to Homeeera Platforms Pvt. Ltd
        </div>
      </motion.div>
    </footer>
  );
};

export default Footer;
